import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function InfoManagerLevel4() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Information Manager Apprenticeship
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Level 4 - Advanced Apprenticeship Programme
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section id="info-manager-level-4" className="info-manager section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  
                  {/* Course Overview */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Course Overview
                    </h3>
                    <div className="alert" style={{ 
                      backgroundColor: '#fff3cd', 
                      border: '1px solid #ffc107', 
                      borderRadius: '8px', 
                      padding: '15px',
                      marginBottom: '20px'
                    }}>
                      <p style={{ color: '#856404', fontSize: '1rem', marginBottom: 0, fontStyle: 'italic' }}>
                        <strong>Important:</strong> You need to be employed to start an Apprenticeship; please include the full contact details of your employer within your application. If you are unable to secure employment, you could enrol on a full-time study programme and transfer to an Apprenticeship later.
                      </p>
                    </div>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The Level 4 Information Manager Apprenticeship Standard is designed to: Support the delivery and management of critical information, whether digital or otherwise, in the (capital) delivery phase of an infrastructure project and the ongoing management of that information within the operational phase of the resulting asset.
                    </p>
                  </div>

                  {/* Details of Standard */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '700', marginBottom: '20px', textAlign: 'center' }}>
                      Details of standard
                    </h4>
                  </div>

                  {/* Occupation Summary */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      Occupation summary
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      This occupation is found in a wide range of sectors and industries such as construction, engineering, manufacturing, transportation including high-speed rail, energy and life sciences, the power industry including nuclear and renewables, local authorities, developers of smart cities and logistics.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The broad purpose of the occupation is to support the delivery and management of critical information, whether digital or otherwise, in the (capital) delivery phase of an infrastructure project and the ongoing management of that information within the operational phase of the resulting asset. The Information Manager ensures that information meets required quality and specifications and is collected, managed and transferred effectively ensuring its value is understood, maximised and reused where it describes its physical asset counterpart (the digital twin). Effective information management not only enables efficiencies to be achieved throughout an asset's lifecycle, but it also provides the opportunity to develop further insight or innovation by using, collaborating and manipulating information in more effective ways. Built assets, whether these are major facilities, large scale developments, engineering projects or significant infrastructure projects require management of information consistent with ISO 19650 (Organisation and digitization of information) or UK BIM (Building Information Modelling) Level 2 approach, or equally other industry information strategies and standards, and in these cases, the Information Manager is required to ensure compliance with these requirements. The Information Manager is a procedural gatekeeper, managing the common data environment (CDE) ensuring it follows the agreed project procedures and that the data is accurate, current and secure. The CDE is the shared source of information used to support collaborative production, management, sharing and exchange of all information during operational and delivery phases whether created in a BIM environment or in a conventional data format.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      In their daily work, an employee in this occupation interacts with a broad range of stakeholders, spanning clients / owners, through to internal and external departments inclusive of engineering, project controls, quality, supply chain, construction, legal and commissioning / completion – in essence, managing information and data as it moves through its lifecycle. It facilitates collaboration between project team members, promotes the development of an informed design and helps avoid duplication and mistakes. Information management holistically addresses the requirements for documentation, data and models in describing a built asset, supporting the delivery of information through the management of integrated systems, processes and people. Whilst normally office based, the Information Manager may need to visit all aspects of the operation from clients' offices, fabrication and vendor sites to construction and partner organisation sites.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      An employee in this occupation will be responsible for managing information through the project's lifecycle and would report to the project or operational manager dependent on the project phase. Within their specialist area, the Information Manager would generally work autonomously and would be expected to exert influence to maintain protocols outside their reporting line including external stakeholders and internal functions. On larger projects, the Information Manager may have a range of specialists reporting to them.
                    </p>
                  </div>

                  {/* Typical Job Titles */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px', textAlign: 'center' }}>
                      Typical job titles include:
                    </h4>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
                      gap: '15px',
                      marginTop: '20px'
                    }}>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Information content specialist
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Information manager - projects
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Information manager
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Project automation specialist
                        </p>
                      </div>
                      <div style={{ 
                        padding: '15px', 
                        backgroundColor: '#fff', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6',
                        textAlign: 'center'
                      }}>
                        <p style={{ color: '#495057', fontSize: '1rem', fontWeight: '500', marginBottom: 0 }}>
                          Project information specialist
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Training Programme Info */}
                  <div className="mb-5">
                    <div className="alert" style={{ 
                      backgroundColor: '#e7f3ff', 
                      border: '1px solid #b3d9ff', 
                      borderRadius: '8px', 
                      padding: '20px'
                    }}>
                      <p style={{ color: '#0066cc', fontSize: '1.05rem', marginBottom: 0 }}>
                        This Apprenticeship is predominantly a work-based training programme designed around the needs of both employers and apprentices and attendance/training at college is one day per week.
                      </p>
                    </div>
                  </div>

                  {/* Qualifications Section */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Qualifications
                    </h3>

                    {/* English and Maths */}
                    <div className="mb-4 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                      <h4 style={{ color: '#495057', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                        English and Maths
                      </h4>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                        Apprentices without level 2 English and maths will need to achieve this level prior to taking the End-Point Assessment. For those with an education, health and care plan or a legacy statement, the apprenticeship's English and maths minimum requirement is Entry Level 3. A British Sign Language (BSL) qualification is an alternative to the English qualification for those whose primary language is BSL.
                      </p>
                    </div>

                    {/* Occupational Level */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#fff', border: '2px solid #7B3F9E', borderRadius: '8px' }}>
                      <p style={{ color: '#495057', fontSize: '1.1rem', fontWeight: '600', marginBottom: 0 }}>
                        <span style={{ color: '#7B3F9E' }}>Occupational Level:</span> 4
                      </p>
                    </div>

                    {/* Duration */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#fff', border: '2px solid #7B3F9E', borderRadius: '8px' }}>
                      <p style={{ color: '#495057', fontSize: '1.1rem', fontWeight: '600', marginBottom: 0 }}>
                        <span style={{ color: '#7B3F9E' }}>Duration (months):</span> 18-24
                      </p>
                    </div>
                  </div>

                  {/* Standard Components */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px', textAlign: 'center' }}>
                      Standard components – ID ST0762
                    </h3>
                    
                    <div style={{ marginTop: '20px' }}>
                      <div className="mb-3 p-3" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                          <a href="https://qualifications.pearson.com/content/dam/pdf/BTEC-Professional-Qualifications/Business-Administration/2014/Specification/BTEC_Prof_L4_BA_Iss2.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#7B3F9E', textDecoration: 'none', fontWeight: '600' }}>
                            BTEC Level 4 Diploma in Business Administration
                          </a>
                        </p>
                      </div>
                      
                      <div className="mb-3 p-3" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                          <a href="https://skillsengland.education.gov.uk/apprenticeship-standards/st0762-v1-0" target="_blank" rel="noopener noreferrer" style={{ color: '#7B3F9E', textDecoration: 'none', fontWeight: '600' }}>
                            Information Manager Personal Attributes and Behaviours
                          </a>
                        </p>
                      </div>
                      
                      <div className="mb-3 p-3" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                          <strong>Functional Skills Maths</strong> - Level 2
                        </p>
                      </div>
                      
                      <div className="mb-3 p-3" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                          <strong>Functional Skills Maths</strong> - Level 2
                        </p>
                      </div>
                      
                      <div className="p-3" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                        <p style={{ color: '#495057', fontSize: '1.05rem', marginBottom: 0 }}>
                          <strong>EPA</strong> – n/a
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default InfoManagerLevel4;